import css from './KeyMapRowButtons.module.scss';
import { KioskTypeName } from '../../../../../API/Enums';
import { GoMotoComponent } from '../../../../../API/GoMoto.types';
import { AppointmentDispatchTypes, useAppointmentDispatch } from '../../../../../context/Appointment/appointment';
import { useKioskState } from '../../../../../context/Kiosk/kiosk';
import { AdminButton } from '../../../../../controls/AdminButton';
import { KeyMapRowButtonsProps } from './KeyMapRowButtons.types';
import { useLocalization } from '../../../../../context/Localization/localization';
import { LocalizationType } from '../../../../../context/Localization/localization.types';
import { ElementType, Fragment } from 'react';
import { KeyExchangeStage } from '../../../../../context/Appointment/appointment.types';

/**
 * The buttons component for each row in the KeyMap component. This component uses mutually exclusive objects
 * to handle a locker having either no associated appointment object but a locker ID or an associated appointment object
 * and no locker ID.
 *
 * @param lockerOpDataType - {@link KeyMapRowButtonsProps.lockerOpDataType lockerOpDataType} description.
 * @param lockerStatus - {@link KeyMapRowButtonsProps.lockerStatus lockerStatus} description.
 * @param lockerId - {@link KeyMapRowButtonsProps.lockerId lockerId} description.
 * @param appointment - {@link KeyMapRowButtonsProps.appointment appointment} description.
 * @param showKeyDropProcessDialog - {@link KeyMapRowButtonsProps.showKeyDropProcessDialog showKeyDropProcessDialog} description.
 * @param onMzeroRetrieveKeyClick - {@link KeyMapRowButtonsProps.onMzeroRetrieveKeyClick onMzeroRetrieveKeyClick} description.
 * @param setLockerId - {@link KeyMapRowButtonsProps.setLockerId setLockerId} description.
 */
export const KeyMapRowButtons: GoMotoComponent<KeyMapRowButtonsProps> = ({
    lockerOpDataType,
    lockerStatus,
    lockerId,
    appointment,
    showKeyDropProcessDialog,
    onMzeroRetrieveKeyClick,
    setLockerId,
}) => {
    const Localization: LocalizationType = useLocalization();
    const { kioskTypeName } = useKioskState();
    const appointmentDispatch = useAppointmentDispatch();

    const isThe247: boolean = kioskTypeName === KioskTypeName.The247;
    const isExpressOrThe365: boolean = kioskTypeName === KioskTypeName.The365 || kioskTypeName === KioskTypeName.TheExpress;
    const isKeyExchangePickup: boolean = lockerOpDataType === 'appointment' && appointment.keyExchangeStage === KeyExchangeStage.AdminKeyRetrieve && isExpressOrThe365;

    const StyleWrapper: ElementType = kioskTypeName === KioskTypeName.The247 ? Fragment : 'div';

    return (
        <StyleWrapper
            {...(!isThe247 && lockerStatus === 'Taken' ? {
                className: css.actions,
            } : undefined)}
        >
            {lockerStatus === 'Taken' && lockerOpDataType === 'appointment' ? (
                <AdminButton
                    onClick={() => {
                        appointmentDispatch({ type: AppointmentDispatchTypes.Update,
                            payload: appointment });

                        if (isThe247) {
                            if (appointment.paymentStatus === 'not paid') {
                                showKeyDropProcessDialog('payment-required');
                            }
                            else {
                                onMzeroRetrieveKeyClick && onMzeroRetrieveKeyClick(appointment);
                            }
                        }
                        else {
                            if (isKeyExchangePickup) {
                                showKeyDropProcessDialog('return-key');
                            }
                            else if (appointment.paymentStatus === 'not paid') {
                                showKeyDropProcessDialog('payment-required');
                            }
                            else {
                                showKeyDropProcessDialog('return-key');
                            }
                        }
                    }}
                    type={'button'}
                    theme={'primary'}
                    label={isKeyExchangePickup ? Localization.RetrieveKey : Localization.ReturnKey}
                    id={isKeyExchangePickup ? Localization.RetrieveKey : Localization.ReturnKey}
                    ariaLabel={isKeyExchangePickup ? Localization.RetrieveKey : Localization.ReturnKey}
                />
            ) : null}
            {!isThe247 ? (
                <AdminButton
                    onClick={() => {
                        if (lockerOpDataType === 'appointment') {
                            appointmentDispatch({ type: AppointmentDispatchTypes.Update,
                                payload: appointment });
                        }
                        else {
                            setLockerId(lockerId);
                        }

                        showKeyDropProcessDialog('open-locker');
                    }}
                    type={'button'}
                    theme={'secondary'}
                    label={Localization.OpenLocker}
                    id={`${Localization.OpenLocker}-taken-not-24-7`}
                    ariaLabel={Localization.OpenLocker}
                />
            ) : null}
        </StyleWrapper>
    );
};